import modalFactory from '@/utils/modalFactory';
import { message } from '@/utils/wuji-message';
import { defineComponent } from '@vue/composition-api';
import classNames from 'classnames';
const cls = 'login-container';
let mounted = false;
const getIframeUrl = () => `/sso/choose_port?via=${document.domain}`;
export const Login = defineComponent({
    setup() {
        const iframeUrl = getIframeUrl();
        return {
            iframeUrl,
        };
    },
    render() {
        return (<div class={classNames('w-0 h-0 pos-absolute overflow-hidden', cls)}>
        <iframe src={this.iframeUrl}/>
      </div>);
    },
});
const mount = modalFactory(Login, {
    parent: () => window.xy_vue_instance,
});
const preloadModal = () => {
    if (mounted) {
        return;
    }
    mounted = true;
    mount();
};
const getLoginIframeTool = () => {
    const iframe = document.querySelector(`.${cls} iframe`);
    if (!iframe) {
        return {};
    }
    return Object.assign({}, iframe.contentWindow?.__loginTool__ || {}, {
        refresh: () => {
            iframe.src = getIframeUrl();
        },
    });
};
export const loginUtil = {
    preloadModal,
    choosePort: (id) => new Promise((done, reject) => {
        const tool = getLoginIframeTool();
        const handleError = (msg) => {
            tool.refresh?.();
            if (window.__xy_sso_loginError === handleError) {
                window.__xy_sso_loginError = undefined;
            }
            message.error(String(msg));
            reject(msg);
        };
        const handleCallback = (prevUrl) => {
            if (window.__xy_sso_switch_account_callback === handleCallback) {
                window.__xy_sso_switch_account_callback = undefined;
            }
            done({ prevUrl });
        };
        window.__xy_sso_switch_account_callback = handleCallback;
        window.__xy_sso_loginError = handleError;
        tool.choosePort?.(id);
    }),
};
